import React from "react";
import { useNavigate } from "react-router-dom";
import { Typography } from "@mui/material";
import ourworkcomp1 from "../../../../assets/ourworkcomp1.svg";
import ourworkcomp2 from "../../../../assets/ourworkcomp2.svg";
import ourworkcomp3 from "../../../../assets/ourworkcomp3.svg";
// import ourworkcomp1png from "../../../../assets/ourworkcomp1png.png";
import ourworkcomp1png from "../../../../assets/citdiffcomp1png1.png";
// import ourworkcomp1pngbelow from "../../../../assets/ourworkcomp1png1below.png";
// import ourworkcomp2png from "../../../../assets/ourworkcomp2png.png";
import ourworkcomp2png from "../../../../assets/citdiffcomp2png2.png";
// import ourworkcomp2pngbelow from "../../../../assets/ourworkcomp2png2below.png";
// import ourworkcomp3png from "../../../../assets/ourworkcomp3png.png";
import ourworkcomp3png from "../../../../assets/citdiffcomp3png3.png";
import ourworkcomp4png from "../../../../assets/citiis_tech_integration.svg";
import diff5 from "../../../../assets/citiis_website_levels.png";
// import ourworkcomp3pngbelow from "../../../../assets/ourworkcomp3png3below.png";
import CustomTooltip from "../../../../common/Tooltip";
import "./style.scss";
import { AOSContainer, AOSWrapper } from "../../../../common/AOSContainer";

const CitiisDifferent = () => {
  const navigate = useNavigate();

  return (
    <div className=" citiisdifferentmaindiv">
      <div className="row secondcompdiv">
        <div
          className="col-md-12 textcities1 ourworkheaderleft"
          style={{ paddingBottom: "30px", paddingLeft: "25px" }}
        >
          <AOSContainer animationType="fade-right">
            <Typography variant="thinmedium" sx={{ color: "white" }}>
              What makes CITIIS
            </Typography>
            <Typography
              variant="thicklarge"
              sx={{
                color: "white",
                lineHeight: "0.9",
              }}
            >
              different
            </Typography>
          </AOSContainer>
        </div>
        <AOSWrapper
          animationType="fade-right"
          className="card col-20"
          style={{
            border: "none",
            background: "transparent",
            paddingLeft: "0px",
            paddingRight: "0px",
          }}
        >
          <div className="card-body withincardcontentourwork ">
            <Typography
              variant="thinsmall"
              className="differentcitiesText"
              // className="paraindi"
              style={{ color: "white" }}
            >
              Promoting Cooperative and Competitive Federalism
            </Typography>
            {/* <Typography
              variant="thinsmall"
              // className="typworkpara paraindi"
              // className="paraindi"
            >
              in
            </Typography>
            <Typography
              variant="thicksmall"
              // className="typworkpara paraindi"
              // className="paraindi"
            >
              12 Cities
            </Typography> */}

            {/* <CustomTooltip title="Click here to read more">
              <button
                className="btn btn-primary btnstyleourwork"
                onClick={() => {
                  navigate("/ourwork");
                  localStorage.setItem("frombtn", "citylevel");
                }}
              >
                Read More
              </button>
            </CustomTooltip> */}
          </div>
          <img
            // className="card-img-top compmobileview"
            className="card-img-top"
            src={ourworkcomp1png}
            alt="Card"
            style={{
              // height: "350px",
              objectFit: "contain",
              width: "89%",
              margin: "auto",
            }}
          />
        </AOSWrapper>

        <AOSWrapper
          animationType="fade-left"
          className="card col-20 "
          style={{
            border: "none",
            background: "transparent",
            paddingLeft: "0px",
            paddingRight: "0px",
          }}
        >
          <div className="card-body withincardcontentourwork2">
            <Typography
              variant="thinsmall"
              className="differentcitiesText"
              // className="typworkpara paraindi2"
              // className="paraindi2"
              style={{ color: "white" }}
            >
              Three-Tier Technical Assistance
            </Typography>
            {/* <Typography
              variant="thinsmall"
              // className="typworkpara paraindi2"
              // className="paraindi2"
            >
              Development Activities
            </Typography>
            <Typography
              variant="thinsmall"
              // className="typworkpara paraindi2"
              // className="paraindi2"
            >
              at{" "}
              <Typography variant="thicksmall" component="span">
                State Level
              </Typography>
            </Typography> */}

            {/* <CustomTooltip title="Click here to read more">
              <button
                className="btn btn-primary btnstyleourwork"
                onClick={() => {
                  navigate("/ourwork");
                  localStorage.setItem("frombtn", "statelevel");
                }}
              >
                Read More
              </button>
            </CustomTooltip> */}
          </div>
          <img
            // className="card-img-top withincardcontent4img compmobileview"
            // className="card-img-top"
            className="card-img-top"
            src={ourworkcomp2png}
            alt="Card"
            style={{
              // height: "350px",
              objectFit: "contain",
              width: "89%",
              margin: "auto",
            }}
          />
        </AOSWrapper>
        <AOSWrapper
          animationType="fade-left"
          className="card col-20 "
          style={{
            border: "none",
            background: "transparent",
            paddingLeft: "0px",
            paddingRight: "0px",
          }}
        >
          <div className="card-body withincardcontentourwork3">
            <Typography
              variant="thinsmall"
              // className="typworkpara paraindi3"
              // className="paraindi3"
              style={{ color: "white" }}
              className="differentcitiesText"
            >
              Maturation Phase for Project Design
            </Typography>

            {/* <CustomTooltip title="Click here to read more">
              <button
                className="btn btn-primary btnstyleourwork"
                onClick={() => {
                  navigate("/ourwork");
                  localStorage.setItem("frombtn", "nationallevel");
                }}
              >
                Read More
              </button>
            </CustomTooltip> */}
          </div>
          <img
            // className="card-img-top compmobileview"
            className="card-img-top "
            src={ourworkcomp3png}
            alt="Card"
            style={{
              // height: "350px",
              objectFit: "contain",
              width: "89%",
              margin: "auto",
            }}
          />
        </AOSWrapper>

        <AOSWrapper
          animationType="fade-left"
          className="card col-20 "
          style={{
            border: "none",
            background: "transparent",
            paddingLeft: "0px",
            paddingRight: "0px",
          }}
        >
          <div className="card-body withincardcontentourwork3">
            <Typography
              variant="thinsmall"
              // className="typworkpara paraindi3"
              // className="paraindi3"
              style={{ color: "white" }}
              className="differentcitiesText"
            >
              Technology Integration through CITIIS Management Platform
            </Typography>

            {/* <CustomTooltip title="Click here to read more">
              <button
                className="btn btn-primary btnstyleourwork"
                onClick={() => {
                  navigate("/ourwork");
                  localStorage.setItem("frombtn", "nationallevel");
                }}
              >
                Read More
              </button>
            </CustomTooltip> */}
          </div>
          <img
            // className="card-img-top compmobileview"
            className="card-img-top "
            src={ourworkcomp4png}
            alt="Card"
            style={{
              // height: "350px",
              objectFit: "contain",
              width: "89%",
              margin: "auto",
            }}
          />
        </AOSWrapper>
        <AOSWrapper
          animationType="fade-left"
          className="card col-20 "
          style={{
            border: "none",
            background: "transparent",
            paddingLeft: "0px",
            paddingRight: "0px",
          }}
        >
          <div className="card-body withincardcontentourwork3">
            <Typography
              variant="thinsmall"
              // className="typworkpara paraindi3"
              // className="paraindi3"
              style={{ color: "white" }}
              className="differentcitiesText"
            >
              Interventions at City, State and National Levels
            </Typography>

            {/* <CustomTooltip title="Click here to read more">
              <button
                className="btn btn-primary btnstyleourwork"
                onClick={() => {
                  navigate("/ourwork");
                  localStorage.setItem("frombtn", "nationallevel");
                }}
              >
                Read More
              </button>
            </CustomTooltip> */}
          </div>
          <img
            // className="card-img-top compmobileview"
            className="card-img-top "
            src={diff5}
            alt="Card"
            style={{
              // height: "350px",
              objectFit: "contain",
              width: "89%",
              margin: "auto",
            }}
          />
        </AOSWrapper>
        {/* <div className="col-md-3 graphicourwork1">
          <Typography variant="thinsmall" className="typworkpara">
            Assisting cities develop
          </Typography>
          <Typography variant="thinsmall" className="typworkpara">
            and implement
          </Typography>
          <Typography variant="thinsmall" className="typworkpara">
            innovation-driven and
          </Typography>
          <Typography variant="thinsmall" className="typworkpara">
            sustainable urban
          </Typography>
          <Typography variant="thinsmall" className="typworkpara">
            infrastructure projects
          </Typography>
        </div>
        <div className="col-md-3 graphicourwork2"></div>
        <div className="col-md-3 graphicourwork3"></div> */}
      </div>
    </div>
  );
};

export default CitiisDifferent;
